import { useQueryClient } from '@tanstack/react-query';
import { packageServices } from '../services/package.service';

export const usePrefetchPackages = () => {
  const queryClient = useQueryClient();

  const prefetchNextPage = (filters, totalPages) => {
    const nextPage = parseInt(filters.page) + 1;
    if (nextPage <= totalPages) {
      queryClient.prefetchQuery({
        queryKey: ['packages', { ...filters, page: String(nextPage) }],
        queryFn: () => packageServices.getPackages({ ...filters, page: String(nextPage) }),
      });
    }
  };

  const prefetchPrevPage = (filters) => {
    const prevPage = parseInt(filters.page) - 1;
    if (prevPage >= 1) {
      queryClient.prefetchQuery({
        queryKey: ['packages', { ...filters, page: String(prevPage) }],
        queryFn: () => packageServices.getPackages({ ...filters, page: String(prevPage) }),
      });
    }
  };

  const prefetchPackage = (packageId) => {
    queryClient.prefetchQuery({
      queryKey: ['package', packageId],
      queryFn: () => packageServices.getPackageById(packageId),
    });
  };

  return { prefetchNextPage, prefetchPrevPage, prefetchPackage };
};
